import Api from '.';
import { DEVURL, SITURL, PRODURL } from './envUrl';

export const createCustomFullkit = async (formData, id) => {
  let headers = {
    'Content-Type': 'application/json',
    'Content-Language': 'en-US',
    'Access-Control-Allow-Origin': '*',
  }
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL;
  apiURL = `${DEVURL}/createCustomFullkit`;

  const response = await axiosInstance({
    url: apiURL,
    method: 'POST',
    data: formData,
  }); 
  return response;
};

export const submitCustomFullkit = async (formData, id,DateTime) => {
  const headers = {
    key: "If-Match",
    value: DateTime,
  };

  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL;
  apiURL = `${DEVURL}/submitCustomFullkit/ASSIGN-WORKLIST ${id}!DEFINECUSTOMFULLKIT_FLOW/DefineCustomFullkit`;

  const submitCustomFullkitData = await axiosInstance({
    url: apiURL,
    method: 'PATCH',
    data: formData,
  });
  return submitCustomFullkitData;
};

export const submitCustomFullkitTask = async (formData, taskKey, DateTime) => {
  const headers = {
    key: "If-Match",
    value: DateTime,
  };

  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL;
  apiURL = `${DEVURL}/customFullkitConfirmTask/ASSIGN-WORKLIST ${taskKey}!CUSTOMFULLKITCONFIRMTASK/CustomFullkitConfirmTask`;

  const submitCustomFullkitTaskData = await axiosInstance({
    url: apiURL,
    method: 'PATCH',
    data: formData,
  });
  return submitCustomFullkitTaskData;
};